import { render, staticRenderFns } from "./TimeAnswer.vue?vue&type=template&id=e8164226&"
import script from "./TimeAnswer.vue?vue&type=script&lang=ts&"
export * from "./TimeAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./TimeAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports